import { useCallback } from 'react'
import { Text } from '@mantine/core'
import { useModals } from '@mantine/modals'

import { TurnaroundHours } from '@/constants'

export type TranscriptOrderDecision =
  | { kind: 'commit'; transcriptOrder: string | null }
  | { kind: 'confirm-surge'; transcriptOrder: string }

export const decideTranscriptOrderChange = (
  value: string,
): TranscriptOrderDecision => {
  if (value === TurnaroundHours.ONE_DAY.toString()) {
    return { kind: 'confirm-surge', transcriptOrder: value }
  }
  return {
    kind: 'commit',
    transcriptOrder:
      value === TurnaroundHours.ROUGH_DRAFT.toString() ? null : value,
  }
}

export const useTranscriptOrderChange = (
  onChange: (transcriptOrder: string | null) => void,
) => {
  const { openConfirmModal } = useModals()

  return useCallback(
    (value: string) => {
      const decision = decideTranscriptOrderChange(value)
      if (decision.kind === 'confirm-surge') {
        openConfirmModal({
          title: (
            <Text size="xl" fw={600}>
              Confirm Surge 1 day turnaround
            </Text>
          ),
          onConfirm: () => onChange(decision.transcriptOrder),
          children: (
            <div>
              Surge turnaround is a non-standard more expensive option.{' '}
              <Text component="span" fw={600}>
                Please confirm that it was requested by the attendee.
              </Text>
            </div>
          ),
          labels: {
            cancel: 'Cancel',
            confirm: 'Confirm order',
          },
          centered: true,
          size: 'xl',
        })
      } else {
        onChange(decision.transcriptOrder)
      }
    },
    [onChange, openConfirmModal],
  )
}
